import * as types from './mutation-types';
import * as actions from './actions';
import authService from '../../services/authentication';
import moment from 'moment-timezone';

const state = {
  error: '',
  successLogin: false,
  authenticated: false,
  successMessage: '',
  loading: false,
  user: {},
  selectedRoleId: null,
};

const getters = {
  authError: (state) => state.error,
  wasLoginSuccessful: (state) => state.successLogin,
  isAuthenticated: (state) => state.authenticated,
  getUser: (state) => {
    return {
      ...state.user,
      facility_UTCOffset: moment.tz(state.user.facility_timezone).utcOffset() / 60,
    };
  },
  authLoading: (state) => state.loading,
  authSuccessMessage: (state) => state.successMessage,
  userMenus: (state) => state.user.menus,
  selectedRoleId: (state) => state.selectedRoleId,
};

const mutations = {
  [types.LOGIN_SUCCESS](state, user) {
    const lastlogin = moment().format();
    user.lastlogin = lastlogin;
    window.localStorage.setItem('user', JSON.stringify(user));
    window.localStorage.setItem('isAuthenticated', 'true');
    state.user = user;
    state.authenticated = true;
    state.loading = false;
    state.error = '';
    state.successLogin = true;
  },
  [types.LOGOUT](state) {
    state.user = {};
    state.loading = false;
    state.error = '';
    state.successLogin = false;
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('isAuthenticated');
    state.authenticated = false;
  },
  [types.SET_SESSION_STATUS](state) {
    const auth = window.localStorage.getItem('isAuthenticated');
    if (auth != null && auth === 'true') {
      state.authenticated = true;
      state.user = authService.getLoggedUser();
    } else {
      state.authenticated = false;
      state.user = {};
    }
  },
  [types.SET_SELECTED_ROLE_ID](state, roleId) {
    state.selectedRoleId = roleId;
  },
  [types.CHANGE_PASSWORD_REQUEST](state) {
    state.error = '';
    state.loading = true;
    state.successMessage = '';
  },
  [types.CHANGE_PASSWORD_SUCCESS](state, successResponse) {
    state.error = '';
    state.loading = false;
    state.successMessage = successResponse.message;
  },
  [types.CHANGE_PASSWORD_FAILURE](state, error) {
    state.error = error;
    state.loading = false;
    state.successMessage = '';
  },
  [types.SETUP_ACCOUNT_REQUEST](state) {
    state.loading = true;
    state.error = '';
    state.successMessage = '';
  },
  [types.SETUP_ACCOUNT_FAILURE](state, error) {
    state.loading = false;
    state.error = error;
    state.successMessage = '';
  },
  [types.SETUP_ACCOUNT_SUCCESS](state, successObject) {
    state.loading = false;
    state.error = '';
    state.successMessage = successObject.message;
  },
  [types.UPDATE_LOCAL_USER_SETTINGS](state, preferences) {
    state.user.preferences = preferences;
    let localUser = JSON.parse(window.localStorage.getItem('user')) || {};
    localUser = {
      ...localUser,
      ...state.user,
    };
    window.localStorage.setItem('user', JSON.stringify(localUser));
  },
  [types.UPDATE_LOCAL_USER_THEME](state, theme) {
    state.user.theme = theme;
    let localUser = JSON.parse(window.localStorage.getItem('user')) || {};
    localUser = {
      ...localUser,
      ...state.user,
    };
    window.localStorage.setItem('user', JSON.stringify(localUser));
  },
  [types.UPDATE_LOCAL_USER_PUSH_NOTIFICATIONS](state, allowPushNotifications) {
    state.user.allowPushNotifications = allowPushNotifications;
    let localUser = JSON.parse(window.localStorage.getItem('user')) || {};
    localUser = {
      ...localUser,
      ...state.user,
    };
    window.localStorage.setItem('user', JSON.stringify(localUser));
  },
  [types.GET_USER_MENUS_SUCCESS](state, menus) {
    state.user.menus = menus;
    let localUser = JSON.parse(window.localStorage.getItem('user')) || {};
    localUser = {
      ...localUser,
      ...state.user,
    };
    window.localStorage.setItem('user', JSON.stringify(localUser));
  },
  [types.GET_USER_MENUS_FAILURE](state) {
    state.user.menus = [];
    let localUser = JSON.parse(window.localStorage.getItem('user')) || {};
    localUser = {
      ...localUser,
      ...state.user,
    };
    window.localStorage.setItem('user', JSON.stringify(localUser));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
